import React, {useMemo, useCallback} from 'react';
import PropTypes from 'prop-types';
import JsonFormsWrapper from '@/components/common/jsonForms/jsonFormsWrapper/JsonFormsWrapper';
import {
  loginActivityJsonSchema,
  loginActivityUiSchema
} from '@/services/schema/activity';
import {useAppSelector} from '@/store';

const LoginActivitySetUp = ({formData, handleFormChange}) => {
  const countryCode = useAppSelector((state) => state.countryCode).countryCode;

  const memoizedJsonSchema = useMemo(
    () => loginActivityJsonSchema(countryCode),
    [countryCode]
  );
  const memoizedUiSchema = useMemo(
    () => loginActivityUiSchema(countryCode),
    [countryCode]
  );

  const memoizedHandleFormChange = useCallback(
    (data) => handleFormChange(data),
    [handleFormChange]
  );

  return (
    <JsonFormsWrapper
      jsonschema={memoizedJsonSchema}
      uischema={memoizedUiSchema}
      data={formData}
      onChange={memoizedHandleFormChange}
    />
  );
};

LoginActivitySetUp.propTypes = {
  formData: PropTypes.object,
  handleFormChange: PropTypes.func.isRequired
};

export default React.memo(LoginActivitySetUp);
